import PropTypes from 'prop-types'
import classNames from 'classnames'

import Typography from '../typography'
import Button from '../button'
import Icon from '../icon'

import Clock from '../icon/time.svg'
import Play from '../icon/playcircle.svg'
import Paperclip from '../icon/paperclip-vertical.svg'
import Medal from '../icon/medal-small.svg'

import styles from '../../../styles/bantrab/components/card.module.scss'

const Buy = ({ duration, classes, files, ...attrs }) => {
  const { className } = attrs
  attrs.className = classNames(className, {
    [styles.buy]: true
  })

  return (
    <div {...attrs}>
      <figure></figure>
      <div className="p-4 pb-6">
        <Button
          arrow
          background
          href="https://www.google.com"
          iconRight
          target="_blank"
        >
          Únete ahora
        </Button>
        <Typography size="four" weight="bold" className="mt-6">Información del curso</Typography>
        <ul className="mt-2">
          <li className="flex items-center">
            <Icon svg={Clock} size={16} />
            <Typography className="ml-2" size="two">Duración: {duration}</Typography>
          </li>
          <li className="flex items-center">
            <Icon svg={Play} size={16} />
            <Typography className="ml-2" size="two">{classes} módulos de acceso ilimitado</Typography>
          </li>
          <li className="flex items-center">
            <Icon svg={Paperclip} size={16} />
            <Typography className="ml-2" size="two">{files} Archivos adjuntos</Typography>
          </li>
          <li className="flex items-center">
            <Icon svg={Medal} size={16} />
            <Typography className="ml-2" size="two">Certíficate al terminar</Typography>
          </li>
        </ul>
      </div>
    </div>
  )
}

Buy.propTypes = {
  duration: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  classes: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  files: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
}

export default Buy
